import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button, IconButton } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './index.scss';
import '../scss/public.scss';
import Color from '@tool/color';
import Head from '../../component/head';
import {
  ChartIconInActive,
  ChartIconActive,
  TableIconInActive,
  TableIconActive,
} from '@styled/icon';
import moLeaveRate, { initLeaveRate, changeType, changeTimeTab } from './store';
import Chart from './chart';
import CommonTable from './table';
import TimeTab from '../../component/time-tab';
import Empty from '@comp/empty/index';
import moUser from '@store/user';
import { exportExcelFile, newRate, newValue, rawRate } from '@tool/index';
import moIndex, { changeDismissionYear, toggleTip } from '../../store/index';

interface IProps {}
interface IState {}

const DIconButton = styled(IconButton)(() => ({
  width: '32px',
  height: '20px',
  marginRight: '2px',
  borderRadius: '3px',
}));

const ActiveType = styled(DIconButton)(() => ({
  backgroundColor: Color.primary,
  '&:hover': { backgroundColor: Color.primary },
}));

const InActiveType = styled(DIconButton)(() => ({
  backgroundColor: Color.fff,
  '&:hover': { backgroundColor: Color.fff },
}));

// 人力指标 - 离职率 - 行业离职率
const LeaveRate = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { isLogin } = moUser;
  const { dismissionYear, defaultDismissionYear, isMock } = moIndex;
  const {
    type,
    activeTime,
    timeList,
    xData,
    yData,
    tableLeft,
    tableRight,
    overview,
    labels,
  } = moLeaveRate;

  const exporttable = () => {
    if (moUser.isIndicatorExpired) {
      toggleTip(true);
      return;
    }
    const list: any = [];
    tableLeft.forEach((item: any, i: any) => {
      const items: any = [item, ...tableRight[i]];
      list.push(items);
    });
    const merge: any = [];
    exportExcelFile(list, merge, '行业离职率');
  };

  useEffect(() => {
    // initLeaveRate();

    return () => {};
  }, []);

  return (
    <section id="indicator2" className="human-indicator_10">
      <Head title="人力指标" bigTitle="离职率" />
      <section className="leave-rate_10">
        <section className="leave-rate_20">
          <p className="one-11">
            <strong>行业离职率</strong>
            <span className="tag-01">行业比对</span>
            {type === 'chart' ? (
              <ActiveType>
                <ChartIconActive />
              </ActiveType>
            ) : (
              <InActiveType onClick={() => changeType('chart')}>
                <ChartIconInActive />
              </InActiveType>
            )}
            {type === 'table' ? (
              <ActiveType>
                <TableIconActive />
              </ActiveType>
            ) : (
              <InActiveType onClick={() => changeType('table')}>
                <TableIconInActive />
              </InActiveType>
            )}
          </p>
        </section>

        {type === 'chart' ? (
          <>
            {!isEmpty(xData) ? (
              <section className="box-11">
                <section
                  className={['box-13', !isMock ? '' : 'mock-100'].join(' ')}
                  style={{ overflowY: 'auto' }}>
                  <section className="chart-title_03">
                    <p className="line-03">
                      <strong>{rawRate(labels?.rate)}</strong>
                      <span>
                        {labels?.year}年{labels?.industry}离职率
                      </span>
                    </p>
                  </section>
                  <section
                    style={{
                      width: '100%',
                      overflowY: 'auto',
                    }}>
                    <Chart height={300} xData={xData} yData={yData} />
                  </section>
                </section>
                <section className="box-150">
                  <strong>解读：</strong>
                  <section className="box-151">
                    {overview.map((text: any, index: number) => (
                      <p key={index}>
                        <span className="ico-11">
                          <b />
                        </span>
                        <i>{text}</i>
                      </p>
                    ))}
                  </section>
                </section>
              </section>
            ) : (
              <Empty padding="50px 0" />
            )}
          </>
        ) : (
          <>
            {type === 'table' && (
              <section onClick={exporttable} className="export-table">
                导出excel
              </section>
            )}
            {!isEmpty(tableRight) ? (
              <section className="box-30top">
                <CommonTable leftList={[tableLeft]} rightList={tableRight} />
              </section>
            ) : (
              <Empty padding="50px 0" />
            )}
          </>
        )}

        {!isEmpty(xData) && type === 'chart' ? (
          <TimeTab
            active={defaultDismissionYear}
            list={dismissionYear}
            onChange={changeDismissionYear}/>
        ) : null}
      </section>
    </section>
  );
};

export default observer(LeaveRate);
